import { fbkSubl } from '@croquiscom-pvt/web2app';

import { Log, Tracker } from '../Tracker';
import { sendWithPageviewHandling } from '../utils/pageviewHelper';
import { UBLSender } from './types';

export function createFbkSender(tracker: Tracker): UBLSender {
  const sender = (log: Log) => {
    const fbk_log = { ...log, client_access_time: Date.now() };
    return sendWithPageviewHandling(fbk_log, fbkSubl);
  };
  return Object.assign(sender, tracker) as UBLSender;
}
